/**
 * 平台: 端外webview
 * 通用能力:
 * 1.bridge None
 * 2.登录: h5SetLoginConfig | h5IsLogin | h5Login
 * 3.定位: h5Locate
 * 4.订阅: None
 * 5.分享: None
 */
import { webxError, webxErrorType, utils } from '@didi/webx-js-core';
import { isHK } from '../../../xenv';
import { getNineChapterCommonParams } from '../../../statistic';
import { getBranch } from '../../../initSDK';
import { is } from '../../../xenv';
import { sdkReady } from '../../loader';
import { query, hashQuery } from '../../../query';
import { storage } from '../../../storage';
import { H5Jump } from './goTo';
function commonJump(loadParams, xenv, commonParams = {}) {
    new H5Jump(loadParams, xenv, commonParams).doJump();
}
const didiLoginConfig = {
    sdkUrl: '//static.udache.com/common/trinity-login/__version__/login.min.js',
    offlineSdkUrl: 'http://passport.qatest.didichuxing.com/static/trinity-login/__version__/login.test.js',
    get appid() {
        let _appid = 30004;
        if (is('passenger')) {
            _appid = 39013;
        }
        else if (is('weixin')) {
            _appid = 30000;
        }
        else if (is('mqq')) {
            _appid = 30001;
        }
        else if (is('alipay')) {
            _appid = 30002;
        }
        else {
            _appid = 30004;
        }
        return _appid;
    },
    role: 1,
    lang: 'zh-CN',
    offline: false,
    country_calling_code: '+86',
    country_id: 156,
    loginType: 'trinity',
    loginJsVersion: isHK ? '2.2.4' : '2.2.1',
    isHalfScreen: true,
    domain_suffix: isHK ? '-hk' : undefined
};
const didiDriverLoginConfig = Object.assign({}, didiLoginConfig, { role: 2 });
const kfLoginConfig = {
    sdkUrl: '//static.hongyibo.com.cn/common/bwh-login/__version__/login.min.js',
    offlineSdkUrl: 'http://passport-test.didichuxing.com/static/trinity-loginB/__version__/login.test.js',
    get appid() {
        let appid;
        if (is('kfpassenger')) {
            appid = 130000;
        }
        else {
            appid = 130006;
        }
        return appid;
    },
    role: 1,
    lang: 'zh-CN',
    offline: false,
    country_calling_code: '+86',
    country_id: 156,
    loginType: 'trinity',
    loginJsVersion: '2.0.6',
    isHalfScreen: true
};
const kfDriverLoginConfig = Object.assign({}, kfLoginConfig, { role: 2 });
let loginConfig = null;
function _getVersionSDKUrl(option) {
    let { offline, loginJsVersion, offlineSdkUrl, sdkUrl } = option;
    let url = offline ? offlineSdkUrl : sdkUrl;
    return url.replace('__version__', loginJsVersion);
}
function _getLoginConf() {
    let branch = getBranch();
    let exhaustiveCheck;
    switch (branch) {
        case 'passenger':
            if (isHK) {
                return Object.assign({}, didiLoginConfig, {
                    country_calling_code: '+852',
                    country_id: 344,
                    canonical_country_code: 'HK'
                });
            }
            else {
                return didiLoginConfig;
            }
        case 'kfpassenger':
            return kfLoginConfig;
        case 'driver':
            return didiDriverLoginConfig;
        case 'kfdriver':
            return kfDriverLoginConfig;
        case 'cxapp':
            webxError({
                type: webxErrorType.API,
                msg: `当前品牌${branch}不允许在端外登录`
            });
            return;
        default:
            exhaustiveCheck = branch; // eslint-disable-line
            webxError({
                type: webxErrorType.API,
                msg: `当前品牌${branch}不允许在端外登录`
            });
            return;
    }
}
const h5SetLoginConfig = (opt) => {
    loginConfig = Object.assign({}, _getLoginConf(), opt);
    // 从WebLoginConf挑出SdkLoginConfig，因为全量传入WebLoginConf会导致sdk报错
    const { sdkUrl, offlineSdkUrl, offline, ...sdkConfig } = loginConfig; // eslint-disable-line
    sdkReady('login', _getVersionSDKUrl(loginConfig), sdk => {
        if (sdk && sdk.setConfig) {
            const { xpsid, xpsid_root } = getNineChapterCommonParams(); // 获取九章参数
            if (sdkConfig.extra_info && Object.values(sdkConfig.extra_info).length) {
                sdkConfig.extra_info = Object.assign({}, sdkConfig.extra_info, { xpsid, xpsid_root });
            }
            else {
                sdkConfig.extra_info = { xpsid, xpsid_root };
            }
            sdk.setConfig(sdkConfig);
        }
    });
};
const h5IsLogin = (option, callback) => {
    return new Promise((resolve, reject) => {
        loginConfig = loginConfig || _getLoginConf();
        sdkReady('login', _getVersionSDKUrl(loginConfig), sdk => {
            const { token, uid, phone } = Object.assign({}, query(), hashQuery());
            const { useQuick } = option || {};
            const setWebxStorage = userInfo => {
                const { token } = userInfo || {};
                storage.userInfo = Object.assign({}, storage.userInfo, userInfo);
                const newRiskParams = Object.assign({}, storage.riskParams, { newTicket: token || undefined });
                utils.cleanEmptyKey(newRiskParams);
                storage.riskParams = newRiskParams;
            };
            const trinityLogin = () => {
                sdk.isLogin(res => {
                    if (res && res.login) {
                        const userInfo = { token: res.ticket, phone: res.cell, uid: res.uid };
                        /* 获取用户信息成功 存入缓存 */
                        setWebxStorage({ ...userInfo });
                        /* 执行传入cb */
                        useQuick && callback && callback({ ...userInfo });
                        /* resolve */
                        resolve({ ...userInfo });
                    }
                    else {
                        /* 获取用户信息失败 存入缓存 */
                        setWebxStorage({});
                        /* reject */
                        reject(res);
                    }
                });
            };
            if (token) {
                if (useQuick) {
                    /* 获取链接上用户信息 存入缓存 */
                    setWebxStorage({ token: token, uid: uid, phone: phone || '' });
                    resolve({ token: token, uid: uid, phone: phone || '' });
                }
                sdk.setTicket(token, trinityLogin, trinityLogin);
            }
            else {
                trinityLogin();
            }
        });
    });
};
const h5Login = () => {
    return new Promise((resolve, reject) => {
        loginConfig = loginConfig || _getLoginConf();
        sdkReady('login', _getVersionSDKUrl(loginConfig), sdk => {
            if (sdk && sdk.login) {
                sdk.login(res => {
                    /* 获取用户信息成功 存入缓存 */
                    storage.userInfo = {
                        phone: res.cell,
                        token: res.ticket,
                        uid: res.uid
                    };
                    let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.ticket });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    resolve({
                        phone: res.cell,
                        token: res.ticket,
                        uid: res.uid
                    });
                }, res => {
                    /* 获取用户信息失败 存入缓存 */
                    storage.userInfo = {};
                    let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    reject(res);
                });
            }
            else {
                reject({ errno: -1, errmsg: '登录sdk加载问题，请检查网络' });
            }
        });
    });
};
const h5Logout = () => {
    return new Promise((resolve, reject) => {
        loginConfig = loginConfig || _getLoginConf();
        sdkReady('login', _getVersionSDKUrl(loginConfig), sdk => {
            if (sdk && sdk.logout) {
                sdk.logout(resolve, reject);
            }
            else {
                reject({ errno: -1, errmsg: '登录sdk加载问题，请检查网络' });
            }
        });
    });
};
const h5LoginCheckPhone = (phone) => {
    return new Promise((resolve, reject) => {
        loginConfig = loginConfig || _getLoginConf();
        sdkReady('login', _getVersionSDKUrl(loginConfig), sdk => {
            if (sdk && sdk.checkPhone) {
                sdk.checkPhone(phone, res => {
                    /* 获取用户信息成功 存入缓存 */
                    storage.userInfo = {
                        phone: res.cell,
                        token: res.ticket,
                        uid: res.uid
                    };
                    let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: res.ticket });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    resolve({
                        phone: res.cell,
                        token: res.ticket,
                        uid: res.uid
                    });
                }, res => {
                    /* 获取用户信息失败 存入缓存 */
                    storage.userInfo = {};
                    let newRiskParams = Object.assign({}, storage.riskParams, { newTicket: undefined });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    reject(res);
                });
            }
            else {
                reject({ errno: -1, errmsg: '登录sdk加载问题，请检查网络' });
            }
        });
    });
};
const h5Locate = () => {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(function (position) {
            /* 获取定位信息成功 存入缓存 */
            storage.locationInfo = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            let newRiskParams = Object.assign({}, storage.riskParams, { latitude: position.coords.latitude, longitude: position.coords.longitude });
            utils.cleanEmptyKey(newRiskParams);
            storage.riskParams = newRiskParams;
            resolve({
                lat: position.coords.latitude,
                lng: position.coords.longitude
            });
        }, function (err) {
            /* 获取定位信息失败 存入缓存 */
            storage.locationInfo = {};
            let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined });
            utils.cleanEmptyKey(newRiskParams);
            storage.riskParams = newRiskParams;
            reject(err);
        }, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        });
    });
};
function _createPayDom() {
    let payDom = null;
    return function () {
        if (payDom)
            return payDom;
        payDom = document.createElement('div');
        payDom.setAttribute('class', '__pay__');
        document.body.appendChild(payDom);
        return payDom;
    };
}
const getOldH5Pay = (options) => {
    let url = '//static.udache.com/public-biz/common-pay-js/version/__version__/pay.js';
    let { pay, version = '0.6.9', lang = 'zh-CN' } = options;
    url = url.replace('__version__', version);
    return new Promise((resolve, reject) => {
        sdkReady('DPay', url, DPay => {
            DPay.pay({
                direct: false,
                pay: pay || {},
                el: _createPayDom()(),
                theme: 'orange',
                router: true,
                lang: lang
            }, function (err, result) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(result);
                }
            });
            DPay.once('close', function (err) {
                reject({
                    err,
                    code: 2
                });
            });
        });
    });
};
const h5Pay = (options) => {
    options = Object.assign({}, options);
    if ('useOld' in options) {
        return getOldH5Pay(options);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let { pay, config, useOld, version, lang, mini_url, successUrl, mini_back, ...args } = options;
    if (!config) {
        config = args;
    }
    return new Promise((resolve, reject) => {
        sdkReady('DpayWeb', 'https://img-ys011.didistatic.com/static/ddpay_fe/DpayWeb-1.1.1.js', DpayWeb => {
            DpayWeb.pay(pay, config);
            DpayWeb.registerPaySuc((res) => {
                resolve(res);
            });
            DpayWeb.registerPayFail((err) => {
                reject(err);
            });
            DpayWeb.registerClose((err) => {
                reject({
                    err,
                    code: 2
                });
            });
        });
    });
};
export { h5Locate, h5SetLoginConfig, h5IsLogin, h5Login, h5Logout, h5LoginCheckPhone, h5Pay, commonJump as h5CommonJump };
